module.exports = __webpack_public_path__ + "static/media/logo.f9ee8ead.png";